export default __webpack_public_path__ + "238060420bf310bbaade3b251e717286.svg";